import { render, staticRenderFns } from "./ImportWizard.template.vue?vue&type=template&id=8b392950&scoped=true&"
var script = {}
import style0 from "./ImportWizard.template.vue?vue&type=style&index=0&id=8b392950&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b392950",
  null
  
)

export default component.exports